import { render, staticRenderFns } from "./AdminManageEmail.vue?vue&type=template&id=32358e8c"
import script from "./AdminManageEmail.vue?vue&type=script&lang=js"
export * from "./AdminManageEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports